import { useState } from "react";
import styled from "styled-components";
import { useImageContentContext } from ".";
import { API_PATHS } from "../../../../../../../API/api_paths";
import { ImageContentProps } from "./imageContent";

export const Image = ({ image }: ImageContentProps.Image) => {
  const { isWithinRepostPost } = useImageContentContext();
  const [isLoaded, setIsLoaded] = useState(false);

  if (!image.id || !image.id.length) return null;
  const imageURL = API_PATHS.posts.getPostImage + image.id;

  return (
    <ImageComponent
      src={imageURL}
      $isClickable={isWithinRepostPost}
      $isLoaded={isLoaded}
      onLoad={() => {
        setIsLoaded(true);
      }}
      alt=""
    />
  );
};

const ImageComponent = styled.img<{
  $isClickable: boolean;
  $isLoaded: boolean;
}>`
  width: 100%;
  display: block;
  cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};
`;
